import { defineNuxtPlugin } from '#app'; // For Nuxt 3 (if you're using Nuxt 2, use 'Vue' directly)
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css'; // or any other theme

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(ToastPlugin);
});
